export default {
	id: 'SIMPLE_PREMIUM_12W_657_12W_387',
	providers: {
		paltaMap: {
			USD: 'prd_aIwfbBigT0Y2',
		},
		primer: 'prd_aIwfbBigT0Y2',
	},
}
